import { UserManager } from "oidc-client-ts";
import { getGoogleSettings, getAzureAdSettings } from "./oidcConfig";

let googleManager: UserManager | null = null;
let azureManager: UserManager | null = null;

export function getGoogleUserManager(): UserManager {
  if (!googleManager) {
    googleManager = new UserManager(getGoogleSettings());
  }
  return googleManager;
}

export function getAzureUserManager(): UserManager {
  if (!azureManager) {
    azureManager = new UserManager(getAzureAdSettings());
  }
  return azureManager;
}

export type OidcProvider = "google" | "azure";
